import Watcher from './Watcher';
import Configuration from './services/Configuration';
import CookieStorage from './services/storage/CookieStorage';
import LocalStorage from './services/storage/LocalStorage';
import onDOMReady from './utils/onDOMReady';
import findAnyElements from './utils/findAnyElements';
import { UPFLOWY_INTENT_SCRIPT_SELECTOR } from './settings';

const config = Configuration.create(UPFLOWY_INTENT_SCRIPT_SELECTOR);

const storage = navigator.cookieEnabled ? CookieStorage : LocalStorage;

onDOMReady(() => {
  const elements = findAnyElements();
  const watcher = new Watcher({
    elements,
    config,
    storage,
  });
  return watcher;
});

export default Watcher;
